module.exports = __webpack_public_path__ + "static/media/team.c30b1b2c.svg";